import CustomerBankAccountDTO from "features/customer/dtos/CustomerBankAccountDTO";
import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import Select from "react-select";
import reactSelectStyles from 'features/shared/components/reactSelect/reactselectcustom.module.scss';
import { formatBankAccount } from "features/shared/helpers/Formatters";
import { Nullable } from "features/shared/types/nullable";
import AddAccountButton from 'features/requirements/components/paymentMethodForm/AddAccountButton';
import { isEmpty } from "features/shared/helpers/objects";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  accounts: CustomerBankAccountDTO[];
  onChange: (bankAccount: Nullable<CustomerBankAccountDTO>) => void;
  selectedAccount?: Nullable<CustomerBankAccountDTO>;
  onBankAccountAddClick: (paymentCategory?: string) => void;
  errors?: Record<string, string>;
  paymentCategory?: string;
}

const BankAccountSelect = ({ name, accounts, onChange, selectedAccount, onBankAccountAddClick, errors, paymentCategory }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  return (
    <FormGroup 
      labelText={tLabels("bankAccountSelect.bankAccount")}
      validationError={errors ? errors[name] : undefined}
    >
      <div className="row no-gutters">
        <div className="col">
          <Select
            options={accounts}
            getOptionLabel={(account) => formatBankAccount(account)}
            getOptionValue={(account) => formatBankAccount(account)}
            value={!isEmpty(selectedAccount!) ? selectedAccount : undefined}
            onChange={onChange}
            isSearchable={false}
            captureMenuScroll={false}
            className={reactSelectStyles.customSelect}
            classNamePrefix="customSelect"
            placeholder={tLabels("bankAccountSelect.setBankAccount")}
            noOptionsMessage={() => tLabels("bankAccountSelect.noBankAccounts")}
          />
        </div>
        <div className="col-auto pl-2">
          <AddAccountButton onClick={() => onBankAccountAddClick(paymentCategory)} />
        </div>
      </div>
    </FormGroup>
  )
}

export default BankAccountSelect;
